import { useDispatch as useAppDispatch, useSelector as useAppSelector } from 'react-redux';

export const useSelector = useAppSelector;

export const useDispatch = () => useAppDispatch();
